import React from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Card, CardContent } from '@material-ui/core';
import AnalyticsViews from '../../atoms/Analytics/AnalyticsViews';
import StripeAllChart from '../../organisms/SubStat/StripeAllChart';
import StripeYearTable from '../../organisms/SubStat/StripeYearTable';
import PaymentWayTable from '../../organisms/SubStat/PaymentWayTable';
import settings from '../../settings';

const useStyles = makeStyles((theme) => ({
  container: {
    flex: 1,
    maxWidth: 'calc(100vw - 16px * 2)',
  },
  block: {
    marginBottom: theme.spacing(2),
  },
  redirect: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignContent: 'center',
    gap: '8px',
    textAlign: 'center'
  },
  bestArticles: {
    marginBottom: theme.spacing(2),
  },
}));

const SubStat = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.container}>
      <style dangerouslySetInnerHTML={{__html: `
        .MuiDrawer-root {
          display: none;
        }
      `}} />

      <div style={{ minHeight: '100vh' }}>
        <Card className={classes.block}>
          <CardContent>
            <div className={classes.redirect}>
              <Button variant="contained" onClick={() => history.push('/statistics')}>Retour vers l'administration</Button>
              <Button variant="contained" href={settings.PaymentProvider.stripeDashboardUrl + 'dashboard'} target="_blank" rel="noreferrer">Statistiques Stripe</Button>
              {!!settings.PaymentProvider.profitwellUrl && <Button variant="contained" href={settings.PaymentProvider.profitwellUrl} target="_blank" rel="noreferrer">Statistiques Stripe avancées</Button>}
            </div>
          </CardContent>
        </Card>

        <AnalyticsViews className={classes.bestArticles}/>

        <StripeAllChart />
        <PaymentWayTable isMobile={true} />
        <StripeYearTable isMobile={true} />
      </div>
    </div>
  );
}

export default SubStat;